<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">TRAFFIC</div>
          </div>
          <div class="chinese">交通</div>
        </div>

        <!-- 底部 -->
        <div class="footerMenu">
          <div
            :class="classNameA"
            @mouseover="classNameA = 'colAHover'"
            @mouseout="classNameA = 'colA'"
            @click="changeDataList(4)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">自</div>
            <div class="chaFont">驾</div>
            <div class="chaFont">路</div>
            <div class="chaFont">线</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameB"
            @mouseover="classNameB = 'colAHover'"
            @mouseout="classNameB = 'colA'"
            @click="changeDataList(3)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">汽</div>
            <div class="chaFont">车</div>
            <div class="chaFont">班</div>
            <div class="chaFont">次</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameC"
            @mouseover="classNameC = 'colAHover'"
            @mouseout="classNameC = 'colA'"
            @click="changeDataList(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">火</div>
            <div class="chaFont">车</div>
            <div class="chaFont">时</div>
            <div class="chaFont">刻</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click="changeDataList(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">飞</div>
            <div class="chaFont">机</div>
            <div class="chaFont">航</div>
            <div class="chaFont">班</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import  "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "Traffic",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    //切换标签
    changeDataList(type) { 
      let name = "TrafficTab";
      this.$store.commit("setChildMenu",4);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/traffic/trafficSwitch.vue